// Mock data for Speaking Mirror website

export const heroData = {
  title: "Transforming Brands Through",
  highlight: "Creative Storytelling",
  subtitle: "Full-scale marketing agency specializing in Digital Marketing & Content Creation",
  locations: ["Kolkata", "Mumbai", "Dubai"],
  heroImage: "https://images.unsplash.com/photo-1519389950473-47ba0277781c"
};

export const services = [
  {
    id: 1,
    title: "Social Media",
    description: "Strategic social media management that builds communities and drives engagement across all platforms.",
    color: "#fa551e"
  },
  {
    id: 2,
    title: "SEO",
    description: "Data-driven search engine optimization to increase your visibility and organic traffic.",
    color: "#fad24b"
  },
  {
    id: 3,
    title: "Content Creation",
    description: "Compelling content that resonates with your audience and tells your brand story.",
    color: "#3dd3ee"
  },
  {
    id: 4,
    title: "Performance Marketing",
    description: "ROI-focused campaigns that deliver measurable results and business growth.",
    color: "#ff8c19"
  },
  {
    id: 5,
    title: "Brand Strategy",
    description: "Comprehensive brand positioning and strategy that differentiates you in the market.",
    color: "#b4dc19"
  },
  {
    id: 6,
    title: "Influencer Marketing",
    description: "Authentic partnerships with influencers to amplify your brand reach.",
    color: "#c8aff0"
  },
  {
    id: 7,
    title: "Branding",
    description: "End-to-end branding solutions from visual identity to brand experience.",
    color: "#78286e"
  }
];

export const portfolioWork = [
  {
    id: 1,
    title: "Atharv Healthcare — Complete Brand Identity",
    client: "Atharv Healthcare",
    category: "Branding",
    image: "/atharv_1_page_1.jpg",
    gallery: ["/atharv_1_page_1.jpg", "/atharv_1_page_2.jpg", "/atharv_1_page_3.jpg", "/atharv_1_page_4.jpg", "/atharv_1_page_5.jpg"],
    description: "Built a complete and consistent brand identity from the ground up — logo, brochures, OPD slips, letterheads, diaries, ID cards, pamphlets, and office gate design. Every element aligned for consistency and trust.",
    longDescription: "For Atharv Healthcare, we worked on building a complete and consistent brand identity from the ground up.\n\nStarting with the logo, we extended the visual language across all key touchpoints—including brochures, OPD slips, letterheads, diaries, ID cards, pamphlets, and even the office gate design. Each element was thoughtfully aligned to ensure consistency and easy recognition.\n\nOur approach focused on creating an identity that not only looks cohesive but also builds trust and credibility at every interaction."
  },
  {
    id: 8,
    title: "The Hungry Guests — Content Creation & Digital Management",
    client: "The Hungry Guests",
    category: "Content Creation",
    image: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/wxx4kamb_Website%20Thumbnail%20THG.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/y5fqenel_THG%20FB%20cover%20copy.jpg",
      "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/yzeq7650_logo%20THG%20copy.jpg"
    ],
    description: "End-to-end content creation and digital management for a YouTube show that captures stories through food, culture, and conversation across India.",
    longDescription: "For The Hungry Guests, a YouTube show, we handled end-to-end content creation and digital management, shaping its presence across platforms.\n\nThe show follows two hosts sharing a meal at a stranger's home across India—capturing stories through food, culture, and conversation. While the core concept was pre-defined, we came in to execute and elevate it through content and storytelling.\n\nFrom shoot execution to social media and overall digital presence, we ensure the show translates seamlessly online and connects with its audience consistently.",
    episodes: [
      { title: "Episode 1", url: "https://youtu.be/fxnfCLsEsRM?si=E-heDM2g1SOgTDcT" },
      { title: "Episode 2", url: "https://youtu.be/hW3veOHxXlQ?si=EtiL5w2ozQKGiW64" },
      { title: "Episode 3", url: "https://youtu.be/nDB6ibeC0YY?si=4hqHtJ86HgV1pWXh" }
    ]
  },
  {
    id: 9,
    title: "India Restaurant — Influencer Marketing",
    client: "India Restaurant",
    category: "Influencer Marketing",
    image: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/reqb8nz7_Website%20Thumbnail%20IR.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/reqb8nz7_Website%20Thumbnail%20IR.jpg"
    ],
    description: "Multiple high-impact influencer campaigns delivering 4.7M+ impressions with top content crossing 1.7M+ views.",
    longDescription: "For India Restaurant, we delivered multiple high-impact influencer campaigns designed to maximize visibility and engagement at scale.",
    highlights: [
      "Total Reach: 4.7M+ impressions generated across platforms",
      "Top Content Performance: Multiple pieces crossed 1M+ views, with the highest reaching 1.7M+",
      "Consistent High Visibility: Several creators delivered 100K+ to 500K+ views, ensuring sustained momentum",
      "Strong Engagement: Thousands of likes, comments, and interactions driving real audience interest",
      "Scaled Creator Strategy: A balanced mix of micro and macro creators to achieve both depth and mass reach"
    ],
    episodes: [
      { title: "Reel 1", url: "https://www.instagram.com/reel/C-mS6_0vjeW/?igsh=MWsxMnF2ZTg1Y3N6bw==" },
      { title: "Reel 2", url: "https://www.instagram.com/reel/DHXxln0zysB/?igsh=MWxhNWRiazA5ZHJxMQ==" },
      { title: "Reel 3", url: "https://www.instagram.com/reel/DHLgOwEyxO1/?igsh=MTR5bnpsYmthdm94dw==" },
      { title: "Reel 4", url: "https://www.instagram.com/reel/C2xHFpUyxgM/?igsh=YXQ3MmZtbW5uZ29m" },
      { title: "Reel 5", url: "https://www.instagram.com/reel/DFmf2INPkRd/?igsh=ZTNrcGphMDM4OTBt" }
    ]
  },
  {
    id: 10,
    title: "Zuhni Ethnic — Social Media",
    client: "Zuhni Ethnic",
    category: "Social Media",
    image: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/1z5bojaw_Website%20Thumbnail%202-02.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/d5lgdrql_Zuhni%201.jpg",
      "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/dgldjw9o_Zuhni%202%20copy.jpg",
      "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/q9z7718x_Zuhni%203.jpg",
      "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/rcxdfypo_Zuhni%204.jpg"
    ],
    description: "Built a visually cohesive and aesthetic social media presence for a designer ethnic wear brand — curated posts, reels, and a refined feed identity.",
    longDescription: "For Zuhni, we focused on building a visually cohesive and aesthetic social media presence aligned with the designer's vision.\n\nThrough carefully curated posts and reels, we translated the essence of the brand into a feed that feels refined, minimal, and true to its identity. Every piece of content was designed to highlight the elegance of the outfits while maintaining a consistent visual language.\n\nThe result is a page that not only showcases the collection but also reflects the mood, detail, and thought behind the brand."
  },
  {
    id: 11,
    title: "Synapse Conclave — Performance Marketing",
    client: "Synapse Conclave (Lucid Lines Productions)",
    category: "Performance Marketing",
    image: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/kfmx75ek_Website%20Thumbnail.jpg.jpeg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/kfmx75ek_Website%20Thumbnail.jpg.jpeg"
    ],
    description: "End-to-end performance marketing for a premium tech conference — 7.2M+ reach, 38 ticket sales, and 4X ROAS from a ₹3.5L budget generating ₹14L revenue.",
    longDescription: "Synapse Conclave is a premium conference by Lucid Lines Productions that brings together global thinkers, scientists, entrepreneurs, and policymakers to explore the future of technology and society — covering AI, Biotechnology, Robotics, Climate Innovation, and more.\n\nWith ticket prices ranging from ₹20,000 to ₹1,00,000, Speaking Mirror designed and executed a full-funnel performance marketing strategy to drive awareness, engagement, and ticket sales for this niche, high-value audience of founders, CXOs, investors, and tech professionals.\n\nFor the Synapse Conclave India campaign, the primary focus was on driving event awareness, digital engagement, and audience participation across online platforms, while building a strong pipeline of qualified leads that translated into conversions and ticket purchases.\n\nSpeaking Mirror worked towards establishing strong digital visibility for the event, ensuring that the right audience not only discovered but also actively engaged with the conference online. Beyond awareness, the strategy focused on capturing high-intent leads, nurturing them through the marketing funnel, and converting interest into confirmed registrations. The objective was not just promotion, but to create meaningful engagement around the conversations and themes associated with Synapse, ultimately driving measurable outcomes in ticket sales.",
    campaignGoals: [
      "Increasing awareness of the Synapse Conclave event across digital platforms while generating high-quality leads.",
      "Growing the social media audience and followers of the Synapse pages, and strategically nurturing this audience towards conversion.",
      "Driving relevant audiences to the event website, capturing leads, and optimizing their journey towards registrations, conversions, and final ticket purchases."
    ],
    campaignSummary: "Through a combination of content distribution and performance marketing campaigns, the strategy focused on expanding the event's digital reach, enhancing audience engagement, generating and nurturing leads, and ultimately converting them into attendees through ticket purchases.",
    highlights: [
      "Total Reach: 7.2M+ across Meta, LinkedIn & Google Ads",
      "Total Impressions: 9.6M+ across all platforms",
      "34,000+ Clicks driving 23,751 Website Visitors",
      "380 Qualified Leads generated from professional audiences",
      "38 Ticket Sales tracked via Meta Pixel",
      "Revenue Generated: ₹14,00,000 from ticket purchases",
      "Marketing Budget: ₹3,50,000 — Return on Ad Spend: 4X ROAS",
      "Meta: 7.1M+ Reach, 158K Engagements, 15K Website Visits",
      "LinkedIn: 119K Professional Reach, 380 Leads",
      "Google Ads: 71K+ Impressions, 1.6K Clicks",
      "Website: 70,416 Page Views, 38,682 Engagement Events"
    ]
  },
  {
    id: 12,
    title: "Confidential Client — SEO & Reputation Management",
    client: "Name changed for privacy reasons",
    category: "SEO & Reputation Management",
    image: "https://images.unsplash.com/photo-1562577309-2592ab84b1bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxTRU8lMjByZXB1dGF0aW9uJTIwbWFuYWdlbWVudCUyMGRpZ2l0YWwlMjBtYXJrZXRpbmclMjBhYnN0cmFjdHxlbnwwfHx8fDE3NzYzMzYyMDB8MA&ixlib=rb-4.1.0&q=85",
    gallery: [],
    description: "Turning a reputation crisis into a credibility comeback — pushed a negative government-domain result beyond page 3 of Google within 2 months.",
    longDescription: "Case Study: Turning a Reputation Crisis into a Credibility Comeback\n\n*Client name has been changed for privacy reasons.\n\n**The Situation**\nWhen someone searched for our client, the first impression wasn't what it should have been. A negative legal document from a high-authority government website was ranking at Position #2 on Google. For a professional whose credibility is everything, this wasn't just a search result — it was a silent reputation crisis. That's when they approached Speaking Mirror.\n\n**The Challenge**\nThis wasn't a typical ORM issue. The source was a government domain — extremely authoritative and difficult to outrank. The content was already indexed strongly by Google. There was limited positive content competing for visibility. In simple terms: we couldn't delete it. We had to outsmart it.\n\n**The Approach**\nWe built a strategy focused on replacing perception, not just removing content.",
    caseStudySections: [
      {
        title: "Rewriting the Narrative",
        text: "We introduced powerful, fact-backed stories that reflected our client's journey, resilience, and professional credibility. One such feature highlighted their transformation story — shifting the narrative from controversy to strength and leadership."
      },
      {
        title: "Content That Competes — and Wins",
        text: "We published and distributed high-quality, SEO-optimized content across credible platforms to: push down the negative result, build a strong ecosystem of positive search results, and establish control over the narrative."
      },
      {
        title: "Strategic Reporting",
        text: "The negative link was systematically reported across multiple channels and accounts, signaling concerns around defamation and contextual inaccuracy."
      },
      {
        title: "Authority Building",
        text: "We didn't stop at suppression. We amplified our client's digital presence through thought leadership content, strategic backlinks, and consistent brand positioning."
      }
    ],
    turningPointIntro: "Within just 2 months, the shift was clear:",
    highlights: [
      "The negative result was pushed beyond the top 3 pages of Google",
      "Positive, credible narratives took over the search landscape",
      "Brand perception moved from questionable to authoritative"
    ],
    ongoingWork: [
      "Monitor search results proactively",
      "Publish strategic content periodically",
      "Strengthen long-term credibility"
    ],
    ongoingNote: "Because reputation management isn't a one-time fix — it's an ongoing advantage.",
    insightQuote: "You don't fight Google — you influence it. And when done right, even the strongest negative results can be replaced with a narrative that truly reflects who you are."
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Joy",
    role: "Founder & Creative Director",
    image: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/ujzao27f_Joy.jpg",
    instagram: "https://www.instagram.com/joydeepsenn/"
  },
  {
    id: 16,
    name: "Aradhana",
    role: "Creative Consultant",
    image: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/k3348ru9_Aradhana.jpg",
    instagram: "https://www.instagram.com/storiesbyaradhana/"
  },
  {
    id: 2,
    name: "Darakshah",
    role: "Sr. Content Strategist",
    image: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/35x7t4oc_Darakshah.jpg",
    instagram: "https://www.instagram.com/darakshah_sohail/"
  },
  {
    id: 5,
    name: "Bidyut",
    role: "Visualiser",
    image: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/roc9l08w_Bidyut.jpg",
    instagram: "https://www.instagram.com/bidyut_s_roy/"
  },
  {
    id: 6,
    name: "Bipplab",
    role: "Sr. Editor",
    image: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/zgue7ixo_Bipplab.jpg",
    instagram: "https://www.instagram.com/bipp_lab/"
  },
  {
    id: 7,
    name: "Rajesh",
    role: "Non-Fiction Editor",
    image: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/g8w70pfr_Rajesh.jpg",
    instagram: "https://www.instagram.com/_rajesh_samanta_/"
  },
  {
    id: 8,
    name: "Rashida",
    role: "Show Editor",
    image: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/m7pq67zo_Rashida.jpg",
    instagram: "https://www.instagram.com/rashidamondal2001/"
  },
  {
    id: 9,
    name: "Sucheta",
    role: "Finance",
    image: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/y9h50k7f_Sucheta.jpg",
    instagram: "https://www.instagram.com/sucheta2003/"
  },
  {
    id: 10,
    name: "Kriti",
    role: "Social Media",
    image: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/f77top7h_Kriti.jpg",
    instagram: "https://www.instagram.com/kiaa_kashyap/"
  },
  {
    id: 11,
    name: "Bapi",
    role: "Administrative Assistant",
    image: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/1u994tbv_Bapi%20Da.jpg"
  },
  {
    id: 13,
    name: "Vishal",
    role: "Production Assistant",
    image: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/bxvdle2y_Vishal.jpg",
    instagram: "https://www.instagram.com/vishal_s194/"
  },
  {
    id: 14,
    name: "Abhijit",
    role: "Non-Fiction Editor",
    image: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/oun1vbcx_Abhijit.jpg",
    instagram: "https://www.instagram.com/abhi.juststarted/"
  },
  {
    id: 15,
    name: "Nilendu",
    role: "Office Support Staff",
    image: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/lpobi8a4_Nilendu.jpg"
  },
  {
    id: 17,
    name: "Aranya",
    role: "Researcher & Script Writer",
    image: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/uid571mg_Aranya.jpg",
    instagram: "https://www.instagram.com/_aranya.aaa_/"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "Speaking Mirror has been instrumental in transforming our overall communication and digital presence. Their team seamlessly handled our PR, social media, video creation, and SEO with a clear understanding of our vision. What stands out is their ability to combine strategy with consistent execution. We've seen a noticeable improvement in our visibility and audience engagement. Their approach is both professional and result-oriented. It has been a truly valuable partnership.",
    author: "Dr. Lal Bhatia, PhD",
    role: "Globally Acclaimed Thought Leader",
    company: ""
  },
  {
    id: 2,
    quote: "Working with Speaking Mirror has been a great experience for us at India Restaurant. Their team has consistently delivered high-quality content across influencer marketing, social media videos, and photo shoots. They truly understand how to showcase our brand in an authentic and engaging way. We've seen a strong improvement in our digital presence and customer engagement. Their creativity, consistency, and professionalism set them apart. It has been a valuable partnership for our brand.",
    author: "Shahmeer Kalim",
    role: "Director",
    company: "India Restaurant"
  },
  {
    id: 3,
    quote: "Speaking Mirror brought clarity, consistency, and results to our communication efforts. Their work has helped Mercy Hospital reach and engage audiences in a far more effective way.",
    author: "Sanjay Prasad",
    role: "Executive Director & CEO",
    company: "Mercy Hospital"
  },
  {
    id: 4,
    quote: "Partnering with Speaking Mirror enabled us to enhance our digital presence, share our story effectively, and build stronger relationships with our customers, employees, and partners through engaging and impactful social media content.",
    author: "Rio Dutta",
    role: "Spokesperson",
    company: "Haldia Petrochemicals Ltd"
  },
  {
    id: 5,
    quote: "Being a new-age digital B2C firm, content and social media have been an important pillar of growth for us. Having a partner like Speaking Mirror, to understand the nuances of social media, build engaging and relatable content, and grow our brand online has been very helpful in our journey.",
    author: "Khushi Poddar",
    role: "Program Manager",
    company: "Yatri Sathi"
  },
  {
    id: 6,
    quote: "As a company committed to environmental sustainability, having a strong digital presence is essential to amplifying our mission and connecting with a broader audience. Partnering with Speaking Mirror for our marketing initiatives is a significant step in this direction. Their expertise will help us create a platform that not only showcases our services effectively but also educates and inspires individuals and organizations to adopt responsible e-waste management practices.",
    author: "Priyasha Singhania",
    role: "CMO",
    company: "Hulladek"
  }
];

export const newsFeatures = [
  {
    id: 1,
    title: "Speaking Mirror Wins Best Digital Agency Award 2024",
    date: "November 2024",
    source: "Marketing Week India",
    excerpt: "Recognized for innovative campaigns and exceptional client results across multiple industries."
  },
  {
    id: 2,
    title: "Expanding Horizons: New Office Opens in Dubai",
    date: "September 2024",
    source: "Business Today",
    excerpt: "Strategic expansion into Middle East market to serve growing client base in the Gulf region."
  },
  {
    id: 3,
    title: "Featured in Top 50 Creative Agencies in Asia",
    date: "July 2024",
    source: "Campaign Asia",
    excerpt: "Listed among Asia's most innovative and impactful creative marketing agencies."
  }
];

export const brands = [
  { id: 1, name: "Lal Bhatia", logo: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/vg0n56j8_Vector%20Smart%20Object.png" },
  { id: 2, name: "Bankura District Police", logo: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/hix9yanx_Bankura%20District%20Police.png" },
  { id: 3, name: "St. Xavier's College", logo: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/s3tf720z_SXC.png" },
  { id: 4, name: "Synapse Conclave", logo: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/1ngm86dp_synapse.jpg" },
  { id: 5, name: "Easy Daftar", logo: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/51imufgb_ED%20LOGO.png" },
  { id: 6, name: "Mercy Hospital", logo: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/asl81amp_49%20Years%20%28NO%20NABH%29.jpg" },
  { id: 7, name: "USEL Group", logo: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/87tspgv2_USEL%20Group%20Logo.png" },
  { id: 8, name: "Yatri Sathi", logo: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/xa34t2zc_Yatri%20Sathi%20LOGO.png" },
  { id: 9, name: "Hulladek Recycling", logo: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/saegko1v_LOGO.png" },
  { id: 10, name: "Hexa TMT", logo: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/dkh9m9ve_hexa%20tmt%20logo.png" },
  { id: 11, name: "Haldia Petrochemicals", logo: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/0kp7drip_hpl%20logo.png" },
  { id: 12, name: "India Restaurant", logo: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/nut5nqvl_India%20restaurant%20Black%20Logo.png" },
  { id: 13, name: "Kasturi", logo: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/qnyfoan5_kasturi%20logo%20hq%20copy.png" },
  { id: 14, name: "IIM Calcutta", logo: "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/ju82l2e0_IIM.png" }
];

export const officeImages = [
  "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/0fglx3yk_b3144bfa-2694-434e-acbd-44f989882db0.jpg",
  "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/z28rgxw4_91e658cd-5106-4867-b0b9-eb664d074624.jpg",
  "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/v5rer4jc_d57e4eb7-464c-4c2e-b013-4d3c4cd7e30f.jpg",
  "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/u79kwge4_ab200091-cd50-44ed-96c8-94f1fba8ff94.jpg",
  "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/ysdwv03k_05695b32-be07-4f24-8bbe-9b0fdbb85218.jpg",
  "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/ndm8u0rq_f2786e55-b04f-4707-a3d3-050916543f65.jpg",
  "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/1ylta6el_d591c673-fda1-4168-a2b5-df2aec63f321.jpg",
  "https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/i4czjnle_c8ff6fa1-c472-427c-b125-d885c7d1dac7.jpg"
];

export const contactInfo = {
  email: "team@speakingmirror.in",
  phone: "+91 9830471770",
  offices: [
    {
      city: "Kolkata",
      address: "Suites 202 & 203, Jasmine Towers, 31 Shakespeare Sarani, Kolkata - 700017",
      mapUrl: "https://maps.app.goo.gl/5EB9HC7Ae5qXgbGB9"
    },
    {
      city: "Mumbai",
      address: "Medina Heights, Sherly Rajan Road, Bandra (W), Mumbai - 400050",
      mapUrl: "https://share.google/40G4I7YQRSdgSbmNY"
    },
    {
      city: "Dubai",
      address: "Villa 14, Aldea Courtyard 12, Area: Wadi Al Safa 5, The Villas, Dubai",
      mapUrl: "https://maps.app.goo.gl/mr9Np2WV4pUDSgcf6"
    }
  ]
};
